import styled, { keyframes } from "styled-components";

const appearOnScreen = keyframes`
  0% {
    transform: translateY(400px);
  }

  100% {
    transform: translateY(0);
  }
`;
const talk = keyframes`
  0% {
    transform: scaleY(0.1);
  }

  100% {
    transform: scaleY(1);
  }
`;

export const AvatarContainerDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 80vw;
  bottom: 86px;
  margin: 10px;
`;

export const AvatarContainerMini = styled.div`
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 150px;
  overflow: hidden;
  background-color: white;
  border-radius: 5px;
  border: 1px solid;
  box-shadow: inset 0 0 10px #8b8b8b;
`;

export const ContainerBodyMini = styled.div`
  position: absolute;
  right: 36px;
  top: 22px;
`;

export const ContainerEyes = styled.div`
  position: absolute;
  right: 30px;
  top: 26px;
  z-index: 3;
`;

export const ContainerMouthMini = styled.div`
  top: 78px;
  right: 27px;
  position: absolute;
  z-index: 0;
  animation: ${talk} 0.1s linear infinite;
  transition-timing-function: cubic-bezier(0.1, 0.1, 1, 1);
`;

export const ContainerMouthMiniOpen = styled.div`
  top: 78px;
  right: 27px;
  position: absolute;
  z-index: 0;
`;

export const TextBox = styled.div`
width: calc(100% - 210px);
padding: 10px;
overflow-y: auto;
height: calc(100% - 20px);
`;

export const Panel = styled.div`
display: flex;
justify-content: center;
align-items: center;
position: absolute;
width: 80vw;
bottom: 0px;
background-color: white;
height: 199px;
width: 83%;
border: 1px solid #e3e3e3;
box-shadow: 0 0 1px #8b8b8b;
border-top-left-radius: 5px;
border-top-right-radius: 5px;
animation: ${appearOnScreen} 0.5s linear;
`;

export const CancelButton = styled.button`
outline: none;
border: none;
background-color: transparent;
&:hover {
  cursor: pointer;
}
`;
